import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForm = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto').style('cursor', 'default')

      if(this.pie.display == 'Y') this.draw_Radial() // -----> draw_Radial.js

      if(this.gantt.display == 'Y') {
        this.gantt_Header()  // -----> draw_Gantt.js
        this.draw_Timeline() // -----> draw_Gantt.js
        this.gantt_Chart()    // -----> draw_Chart.js
      }

      if(this.table.display == 'Y') this.table_Header()

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }

    },

  }
}